export default __webpack_public_path__ + "static/media/boomoleLogo.08524c4d.png";